import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListSubtitleDirective } from './list-subtitle.directive';

@NgModule({
  declarations: [ListSubtitleDirective],
  imports: [CommonModule],
  exports: [ListSubtitleDirective],
})
export class ListSubtitleModule {}
